import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import chunk from 'lodash/chunk'
import Mixin from 'components/common/Mixin'
import TireLineTile from './TireLineTile'
import { Wrapper, Heading } from './common'

const GridTireLines = ({ tireLines }) => Object.keys(tireLines).sort().map(brand =>
  <GridWrapper key={ brand }>
    <Heading headline_narrow data-at-tireline-brand>{ brand }</Heading>
    <GridContainer>
      {
        chunk(tireLines[brand], 3).map(tireRow =>
          <GridRow key={ tireRow.map(({ productId }) => productId).join('-') }>
            {
              tireRow.map(tireProps =>
                <TireLineTile
                  key={ tireProps.productId }
                  { ...tireProps } />
              )
            }
          </GridRow>
        )
      }
    </GridContainer>
  </GridWrapper>
)

export default GridTireLines

GridTireLines.propTypes = {
  tireLines: PropTypes.shape()
}

const GridWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: center;
  ${Mixin.responsive('padding-bottom', '50px', '0')}
`

const GridRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${Mixin.responsive('min-width', '732px', 'unset')}
  ${Mixin.responsive('flex-direction', 'row', 'column')}

  &:not(:last-of-type) {
    ${Mixin.responsive('padding-bottom', '40px', '45px')}
  }
`
